<template>
  <v-app>
    <ListSoftware v-if="usuario != null"></ListSoftware>
    <v-main style="background: #f2f2f2;">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import ListSoftware from './components/ListSoftware.vue'
export default {
  name: 'App',

  data: () => ({
    //
  }),
  computed:{
    ...mapState(['usuario'])
  },
  components:{
    ListSoftware
  }
};
</script>
